const initialState = {};

const permissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PERMISSIONS":
      return {
        ...state,
        permissionList: action.payload,
      };
    default:
      return state;
  }
};

export default permissionsReducer;
